import React, { PropsWithChildren, useEffect, useMemo } from 'react';
import { useNavigate } from "react-router";
import { useAuthContext } from "../launcher/auth/LauncherAuthContext";
import { message } from "antd";
import { useLocation } from "react-router-dom";
import { OauthLoginButton } from "../launcher/auth/OauthLoginButton";
import { useTranslation } from "react-i18next";

export const EnsureLoggedIn: React.FC<PropsWithChildren & { shouldBeAdmin?: boolean; shouldBeOrganizer?: boolean }> = (props) => {
    const { children, shouldBeAdmin, shouldBeOrganizer } = props;
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { isUserLoggedIn, isAdmin, isUserVerified, user } = useAuthContext();
    const isOrganizer = useMemo(() => !!user?.organizer, [user]);

    const location = useLocation();
    const currentPath = location.pathname;

    useEffect(() => {
        if (!!shouldBeAdmin && !isAdmin()) {
            message.warning(t('auth.no.access'));
            navigate('/');
            return;
        }
        if (!!shouldBeOrganizer && !isOrganizer) {
            message.warning(t('auth.no.access'));
            navigate('/');
            return;
        }
        if (isUserLoggedIn() && !isUserVerified()) {
            message.warning(t('auth.need.to.verify.mobile.number'));
            navigate('/signup');
        }
    }, [isUserLoggedIn, isUserVerified, shouldBeAdmin, shouldBeOrganizer, isOrganizer, user, navigate]);

    if (!shouldBeAdmin && !shouldBeOrganizer && !isUserLoggedIn()) {
        return <OauthLoginButton redirectLocation={currentPath} />
    }

    return (
        <>
            {children}
        </>
    )
}